export default [
  {
    category: 'SuperStar',
    name: 'George Tsiolis',
    gitlab: 'https://gitlab.com/gtsiolis',
    merged_mrs: 226,
  },
  {
    category: 'SuperStar',
    name: 'Vitaliy Klachkov',
    gitlab: 'https://gitlab.com/blackst0ne',
    merged_mrs: 117,
  },
  {
    category: 'SuperStar',
    name: 'Jasper Maes',
    gitlab: 'https://gitlab.com/jlemaes',
    merged_mrs: 109,
  },
  {
    category: 'SuperStar',
    name: 'Takuya Noguchi',
    gitlab: 'https://gitlab.com/tnir',
    merged_mrs: 88,
  },
  {
    category: 'Star',
    name: 'gfyoung',
    gitlab: 'https://gitlab.com/gfyoung',
    merged_mrs: 63,
  },
  {
    category: 'Star',
    name: 'Jacopo Beschi',
    gitlab: 'https://gitlab.com/jacopo-beschi',
    merged_mrs: 53,
  },
  {
    category: 'Star',
    name: 'Marcel Amirault',
    gitlab: 'https://gitlab.com/Ravlen',
    merged_mrs: 50,
  },
  {
    category: 'Star',
    name: 'Ben Bodenmiller',
    gitlab: 'https://gitlab.com/bbodenmiller',
    merged_mrs: 49,
  },
  {
    category: 'Star',
    name: 'Praveen Arimbrathodiyil',
    gitlab: 'https://gitlab.com/pravi',
    merged_mrs: 25,
  },
  {
    category: 'Star',
    name: 'Semyon Pupkov',
    gitlab: 'https://gitlab.com/artofhuman',
    merged_mrs: 24,
  },
  {
    category: 'Star',
    name: 'Jan Beckmann',
    gitlab: 'https://gitlab.com/kingjan1999',
    merged_mrs: 18,
  },
  {
    category: 'Star',
    name: 'Johann Hubert Sonntagbauer',
    gitlab: 'https://gitlab.com/johann.sonntagbauer',
    merged_mrs: 15,
  },
  {
    category: 'Star',
    name: 'Tao Wang',
    gitlab: 'https://gitlab.com/twang2218',
    merged_mrs: 12,
  },
  {
    category: 'Enthusiast',
    name: 'Alexis Reigel',
    gitlab: 'https://gitlab.com/koffeinfrei',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Matthias van de Meent',
    gitlab: 'https://gitlab.com/matthias.vandemeent',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Maxime',
    gitlab: 'https://gitlab.com/miouge',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Riccardo Padovani',
    gitlab: 'https://gitlab.com/rpadovani',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Edwin Torres',
    gitlab: 'https://gitlab.com/CoachEd',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Elan Ruusamäe',
    gitlab: 'https://gitlab.com/glensc',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'J.D. Bean',
    gitlab: 'https://gitlab.com/jdbean',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Jamie Schembri',
    gitlab: 'https://gitlab.com/shkm',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Marc Schwede',
    gitlab: 'https://gitlab.com/schwedenmut',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Robert Schilling',
    gitlab: 'https://gitlab.com/razer6',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Amit Rathi',
    gitlab: 'https://gitlab.com/amit1rrr',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Chris Baumbauer',
    gitlab: 'https://gitlab.com/cab105',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Eddie Stubbington',
    gitlab: 'https://gitlab.com/edstub207',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Fabian Schneider',
    gitlab: 'https://gitlab.com/fabsrc',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Harry Kiselev',
    gitlab: 'https://gitlab.com/harrykiselev',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Hiroyuki Sato',
    gitlab: 'https://gitlab.com/hiroponz',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Lars Greiss',
    gitlab: 'https://gitlab.com/lgreiss',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Onuwa Nnachi Isaac',
    gitlab: 'https://gitlab.com/iamonuwa',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Peter Marko',
    gitlab: 'https://gitlab.com/petermarko',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Thomas Pathier',
    gitlab: 'https://gitlab.com/tpxp',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'haseeb',
    gitlab: 'https://gitlab.com/haseebeqx',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'maxmeyer',
    gitlab: 'https://gitlab.com/maxmeyer',
    merged_mrs: 5,
  },
];
